document.addEventListener("DOMContentLoaded", function () {
  const bar = document.getElementById("free-shipping-bar");
  const popup = document.getElementById("free-delivery-popup");
  const threshold = 3000;

  function showPopup() {
    popup.classList.add("show");

    // Hide after 4 seconds
    setTimeout(() => {
      popup.classList.remove("show");
    }, 4000);
  }

  function updateBar(cart) {
    const total = cart.total_price / 100;

    if (total >= threshold) {
      bar.innerText = "🎉 Mubarak ho! Aap ki delivery FREE hai.";
      bar.style.backgroundColor = "#d4edda";
      bar.style.color = "#155724";

      if (!popup.dataset.shown) {
        showPopup();
        popup.dataset.shown = "true";
      }

    } else {
      const remaining = threshold - total;
      bar.innerText = `🛒 Aap ne Rs. ${total} ki shopping ki hai. Rs. ${remaining} ki aur shopping karein FREE delivery ke liye.`;
      bar.style.backgroundColor = "#fff3cd";
      bar.style.color = "#856404";

      popup.dataset.shown = "";
    }
  }

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => updateBar(cart))
    .catch(() => {
      bar.innerText = "Cart info load nahi ho saki.";
    });
});
